import React from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import useHttp from "../hooks/use-http";

const MiniNavigation = () => {
  const navigate = useNavigate();
  const { sendRequest } = useHttp();

  const { id } = useParams();

  const goBackHandler = () => {
    navigate(-1);
  };
  const handleGoBackClick = () => {
    goBackHandler();
  };

  const confirmCancel = (data) => {
    window.location.href = data?.data?.returnUrl;
  };

  const cancelTransaction = async () => {
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/api/transaction/cancelTransaction/${id}`,
        headers: { "Content-Type": "application/json" },
      },
      confirmCancel
    );
  };

  const getCssVar = (name) =>
    getComputedStyle(document.documentElement).getPropertyValue(name).trim();

  const primaryColor = getCssVar("--primary") || "#02AFF3";

  return (
    <>
      <div className="lg:flex items-center md:w-[562px] lg:w-[480px] xl:w-[562px] w-[300px] hidden">
        <div
          className="flex items-center gap-1 cursor-pointer"
          onClick={handleGoBackClick}
        >
          <span>
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.71 16.3219L10.83 12.4419L14.71 8.56187C15.1 8.17187 15.1 7.54188 14.71 7.15187C14.32 6.76188 13.69 6.76188 13.3 7.15187L8.70998 11.7419C8.31998 12.1319 8.31998 12.7619 8.70998 13.1519L13.3 17.7419C13.69 18.1319 14.32 18.1319 14.71 17.7419C15.09 17.3519 15.1 16.7119 14.71 16.3219Z"
                fill="#323232"
              />
            </svg>
          </span>
          <p>Go Back</p>
        </div>
        <span
          onClick={cancelTransaction}
          className="lg:mr-4 absolute right-0 lg:right-24 xl:right-0"
        >
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_703_5431)">
              <path
                d="M18 35.7096C27.7808 35.7096 35.7097 27.7807 35.7097 17.9999C35.7097 8.21916 27.7808 0.290283 18 0.290283C8.21922 0.290283 0.290344 8.21916 0.290344 17.9999C0.290344 27.7807 8.21922 35.7096 18 35.7096Z"
                fill={primaryColor}
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16.8934 18L11.9684 13.0751C11.8258 12.9275 11.747 12.7298 11.7487 12.5246C11.7505 12.3194 11.8328 12.1231 11.9779 11.978C12.123 11.8329 12.3193 11.7506 12.5245 11.7488C12.7297 11.747 12.9274 11.8259 13.075 11.9685L18 16.8934L22.9249 11.9685C23.0725 11.8259 23.2702 11.747 23.4754 11.7488C23.6806 11.7506 23.8769 11.8329 24.022 11.978C24.1671 12.1231 24.2494 12.3194 24.2512 12.5246C24.253 12.7298 24.1741 12.9275 24.0315 13.0751L19.1066 18L24.0315 22.925C24.1741 23.0726 24.253 23.2703 24.2512 23.4755C24.2494 23.6807 24.1671 23.877 24.022 24.0221C23.8769 24.1672 23.6806 24.2495 23.4754 24.2513C23.2702 24.253 23.0725 24.1742 22.9249 24.0316L18 19.1066L13.075 24.0316C12.9274 24.1742 12.7297 24.253 12.5245 24.2513C12.3193 24.2495 12.123 24.1672 11.9779 24.0221C11.8328 23.877 11.7505 23.6807 11.7487 23.4755C11.747 23.2703 11.8258 23.0726 11.9684 22.925L16.8934 18Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_703_5431">
                <rect width="36" height="36" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>
      </div>
    </>
  );
};

export default MiniNavigation;
